import React from "react";
import { Link } from "react-router-dom";

function productCard({ product ,productCss,showProductCss}) {
  const extractedId = product.id.substring(product.id.lastIndexOf("/") + 1);

  return (
    <div className={` ${productCss} ${showProductCss} flex-shrink-0 justify-self-start items-start gap-2 bg-white hover:shadow-lg cursor-pointer overflow-hidden group`}>
  <Link to={`/products/${extractedId}`}>
  {/* <Link to={`/products/${product.id}`}> */}
    <div className="relative">
      <img className="w-full" src={product.featuredImage.url} alt={product.title} />
      {/* Assuming you want to display the first image from the "images" array as the hover image */}
      {product.images.nodes[1] && (
        <img loading="lazy"
          className="top-0 left-0 absolute opacity-0 group-hover:opacity-100 w-full transition-opacity duration-300 ease-in-out"
          src={product.images.nodes[1].url}
          alt={product.title}
        />
      )}
    </div>
    <div className="mt-2 capitalize">
      <h2 className="group-hover:font-bold font-primaryFont text-[11px] text-primary tracking-[1px]">{product.title}</h2>
      <p className="mt-2 font-secondaryFont text-[12px] text-primary">Rs. {product.priceRange.minVariantPrice.amount}</p>
      {/* <p className="mt-1 font-secondaryFont text-[12px] text-primary">Available Sizes:</p> */}
      {product.options.find(option => option.name === 'Size') && (

      <ul className="flex justify-start items-start gap-3 mt-1 font-secondaryFont text-[12px] text-primary">
        {product.options.find(option => option.name === 'Size').values.map((size, index) => (
          <li key={index}>{size}</li>
        ))}
      </ul>
      )}
    </div>
  </Link>
</div>
  );
}

export default productCard;
